import { PersonBonus, DataVehicles, BonusCampaign, GetPersonUser } from '@esportal/portal-service';
import {
	HuchaDisclaimer1Text,
	HuchaDisclaimer2Plus15Text,
	HuchaDisclaimer2S10To15Text,
} from '../../components/benefits/hucha/components/disclaimers/hucha-disclaimers';
import { getHuchaTierFromDiscounts } from '../../components/benefits/hucha/helpers/get-renovador-tier';
import { NamedDisclaimer } from './disclaimers-utils';
import {
	AlertDisclaimerText1,
	AlertDisclaimerText2,
	findBonusAlert,
	noVehicleOrder2025,
} from './alert-disclaimers-utils';

const getHuchaDisclaimers = (userData: GetPersonUser | null): string[] => {
	const huchaTier = getHuchaTierFromDiscounts(userData?.portalUser?.data?.clubVW?.discounts ?? []);

	if (huchaTier === 'renovador10To15') {
		return [HuchaDisclaimer1Text, HuchaDisclaimer2S10To15Text];
	}

	if (huchaTier === 'renovadorPlus15') {
		return [HuchaDisclaimer1Text, HuchaDisclaimer2Plus15Text];
	}

	return [HuchaDisclaimer1Text];
};

export const getAllDisclaimers = (
	personBonus: PersonBonus | null,
	vehicles: DataVehicles | null,
	userData: GetPersonUser | null,
): NamedDisclaimer[] => {
	if (!vehicles || !personBonus || !userData) return [];

	const textToIndexMap = new Map();
	const disclaimers: NamedDisclaimer[] = [];
	let uniqueIndex = 1;

	let bonusDisclaimers: string[] = [];
	let alertsDisclaimers: string[] = [];

	// add hucha disclaimers text
	const huchaDisclaimers = getHuchaDisclaimers(userData);

	// add alerts disclaimers text
	if (noVehicleOrder2025(vehicles) && !findBonusAlert(BonusCampaign.IDWeChargePostPedido, personBonus)) {
		alertsDisclaimers.push(AlertDisclaimerText1);
	}

	if (findBonusAlert(BonusCampaign.IDWeChargePostPedido, personBonus)) {
		alertsDisclaimers.push(AlertDisclaimerText2);
	}

	// add bonus disclaimers text
	personBonus.bonus
		.filter((b) => b.legalText && b.legalText.trim())
		.forEach((b) => {
			const processedText = b.legalText
				.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
				.replace(/__(.*?)__/g, '<u>$1</u>');
			bonusDisclaimers.push(processedText);
		});

	const allDisclaimersText: string[] = [...bonusDisclaimers, ...alertsDisclaimers, ...huchaDisclaimers];

	allDisclaimersText.forEach((text) => {
		if (!textToIndexMap.has(text)) {
			textToIndexMap.set(text, uniqueIndex);
			disclaimers.push({
				ref: `${uniqueIndex}.`,
				text,
			});
			uniqueIndex++;
		}
	});

	return disclaimers;
};
